app.controller('CIFKTP-CTRL',
    ['$scope', 'deviceDetector', '$rootScope', '$uibModal', '$http', '$window', '$q', '$filter',
    function ($scope, deviceDetector, $rootScope, $uibModal, $http, $window, $q, $filter) {

    $scope.CIFInvestor = {};
    $scope.ktpPhoto = '';
    $scope.device = deviceDetector;
    $scope.append = '';
    $scope.editMode = false;
    $scope.statusCamera = 'true';

    $scope.openCamera = function () {
        let message = 'KTP';
        let url = 'ModalCamera.html';
        let ctrl = 'CameraController';
       

        //if ($scope.device.isMobile())
        //{
            //url = 'ModalBrowse.html';
            //ctrl = 'BrowseController';
            $scope.append = 'data:image/png;base64,';
        //}

        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: url,
            controller: ctrl,
            size: 'md',
            resolve: {
                items: function () {
                    return message;
                }
            }
        });
        modalInstance.result.then(function (resolvedResponse) {
            //console.log('ktp',resolvedResponse);
            if (resolvedResponse) {
                $scope.ktpPhoto = resolvedResponse;
            }
        }, function () { });
    };

    $scope.KTPremove = function () {
        $scope.ktpPhoto = '';
    };

    $scope.KTPcapture = function () {
        $scope.$broadcast('ngWebcam_capture');
    };

    $scope.KTPonCaptureComplete = function (src) {

        $scope.series5 = [];
        for (var i = 0; i < src.length; i++) {
            $scope.series5.push(src[i]);
        }
        $scope.submit();

    };

    $scope.KTPonLoad = function () {
        // $log.info('ktp.onLoad');
        console.log('load');
    };

    $scope.KTPonError = function (err) {
        $scope.statusCamera = '';
        console.log(" stat : ", $scope.statusCamera);
        Swal.fire('Error', 'Mohon maaf anda tidak dapat melanjutkan proses selanjutnya karena perangkat anda tidak terdeteksi kamera', 'error');
    };

    $scope.KTPconfig = {
        //viewerWidth: 300,
        //viewerHeight: 300,
        outputWidth: 1000,
        outputHeight: 1000,
        delay: 5,
        shots: 8,
        countdown: 0,
        flashFallbackUrl: 'dist/webcamjs/webcam.swf',
        shutterUrl: 'shutter.mp3',
        flashNotDetectedText: 'Camera not found or use Chrome Browser'
    };

    var allPromise = $q.all([
        //$http({
        //    method: 'POST',
        //    url: 'service/client.svc/retrieveSession',
        //}).then(function (data) {
        //    if (!data.data.d) {
        //        $http({
        //            method: 'GET',
        //            url: 'service/client.svc/SignOut',
        //        }).then(function (data) {
        //            if (data.data.d == true) {
        //                $window.location.href = "#/login";
        //                $window.location.reload();
        //            }
        //        }, function (error) { })
        //    }
        //    else
        //        $scope.currentUser = data.data.d;
        //}, function (error) { }),

      
    ]);



    allPromise.then(function () {
        //$http({
        //    method: 'GET',
        //    url: 'service/client.svc/getCIF',
        //}).then(function (data) {
        //    if (data.data.d != null) {
        //        var obj = data.data.d;
        //        $scope.CIFInvestor = data.data.d;
        //        $scope.CIFInvestor.Stage = 1;


        //    } // END IF data.data.d
        //}, function (error) { });
    });

    $scope.submit = function (item)
    {
        if (item.base64) {
            {
                let image = item.base64.replace("data:image/jpeg;base64,", "");
                var urlsvc = 'service/client.svc/OCRKTP'; // 1
                var preconfirmtranslate = "submitocr"; // 2
                var postData = { ktpimage: image } // 3
                var method = "POST" // 4
                $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (data) {


                    if (data) {
                        if (data.message == "uploadsuccess") {
                            $scope.ocrVerijelas = true;
                            window.location.href = "#/cif/data-pribadi";
                        } else {
                            var SWALtranslate = $scope.SWALtranslate(data.message);
                        }
                    }
                });
            }
        }

        //console.log($scope.ktpPhoto);
        //if ($scope.ktpPhoto) {
        //    {
        //        let image = $scope.ktpPhoto.replace("data:image/jpeg;base64,", "");
        //        var urlsvc = 'service/client.svc/OCRKTP'; // 1
        //        var preconfirmtranslate = "submitocr"; // 2
        //        var postData = { ktpimage: image } // 3
        //        var method = "POST" // 4
        //        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (data) {


        //            if (data) {
        //                if (data.message == "uploadsuccess") {
        //                    $scope.ocrVerijelas = true;
        //                    window.location.href = "#/cif/data-pribadi";
        //                } else {
        //                    var SWALtranslate = $scope.SWALtranslate(data.message);
        //                }
        //            }
        //        });
        //    }
        //}
    }
        
   


    //$scope.submit = function (item) {
    //    //console.log(item);
    //    if (item.base64)
    //    {
    //        let image = item.base64.replace("data:image/jpeg;base64,", "");
    //        console.log('start OCR');
    //        $rootScope.AlertYesNo('warning', 'Loading...', '', 2);
    //        $http({
    //            method: 'POST',
    //            url: 'service/client.svc/OCRKTP',
    //            data: {
    //                "ktpimage": image
    //            },
    //        }).then(function (data) {
    //            console.log('done OCR');
    //            swal.close();
    //            if (data.data.d.result) {
    //                $scope.ocrVerijelas = true;
    //                $window.location.href = "#/cif/data-pribadi";
    //            }
    //            else {
    //                if(data.data.d.message)
    //                    swal('Error', data.data.d.message, 'error');
    //                else
    //                    swal('Error', 'Foto KTP tidak sesuai/kurang jelas', 'error');
    //            }

    //        }, function (error) {
    //            swal('Error', 'error - Please check your connection' + error, 'error');
    //        });
    //    }
    //    else
    //    {
    //        swal('Error', 'Please take id card photo', 'error');
    //    }
    //}

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: 'service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };

    $scope.print = function () {
        $scope.prepareData();
    }

}]);

